import styled from 'styled-components'

const DetailTable = styled.div`
 background: #F7F8FA;
 border-radius: 8px;
 
`

export default DetailTable
